// @capacitor/camera rejects with this message on both iOS and Android when
// the user closes the camera without taking a photo.
export function isCameraCancel(err: unknown): boolean {
  const message = err instanceof Error ? err.message : String(err ?? '');
  return /cancel/i.test(message);
}
